import _createForOfIteratorHelper from "/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _regeneratorRuntime from "/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
export default {
  data: function data() {
    return {
      url: '登录中，请稍等...'
    };
  },
  activated: function activated() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this.getQueryVariable();
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    // 获取url参数
    getQueryVariable: function getQueryVariable() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var url, urlarr, _iterator, _step, item;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this2.paramRequest = {};
              url = window.location.href.split('?')[1];
              urlarr = url.split('&');
              _iterator = _createForOfIteratorHelper(urlarr);
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  item = _step.value;
                  _this2.paramRequest[item.split('=')[0]] = item.split('=')[1]; // 前者为参数名称，后台为参数值
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              console.log('getQueryVariable', _this2.paramRequest);
              _context2.next = 8;
              return _this2.login();
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    } // 获取token
    ,
    login: function login() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this3.$api['wxWebLogin']('admin', _this3.paramRequest.code).then(function (res) {
                console.log('login', res.data);
                if (res.data) {
                  // this.$router.replace(this.$route.query.redirect || '/')
                  localStorage.setItem('token', res.data.token);
                  window.parent.location.href = localStorage.getItem('wx_web_login_callback_url') + '#/';
                } else {
                  _this3.$message.error(res.msg);
                  localStorage.setItem('token', res.data.token);
                  _this3.url = '登录失败，请刷新二维码重试';
                }
              });
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    }
  }
};